import { Share } from '@capacitor/share';
import { Capacitor } from '@capacitor/core';

// Invite links. A room code is fine when two people are in the same room;
// a friend on WhatsApp gets a link that opens the app straight into the
// lobby (Android App Links) or, without the app, plays in the browser.
// The web origin is the only thing that changes when the domain does.
export const WEB_ORIGIN =
  (import.meta.env.VITE_WEB_ORIGIN as string | undefined) || 'https://wot.aimtech.ai';

export function inviteUrl(code: string): string {
  return `${WEB_ORIGIN}/j/${code.toUpperCase()}`;
}

/** The code inside an invite URL (web load or native appUrlOpen), else null. */
export function inviteCodeFromUrl(url: string): string | null {
  try {
    const u = new URL(url);
    const m = u.pathname.match(/^\/j\/([A-Za-z0-9]{4,8})\/?$/);
    return m ? m[1].toUpperCase() : null;
  } catch {
    return null;
  }
}

export type ShareResult = 'shared' | 'copied' | 'failed';

/** System share sheet where there is one, clipboard where there is not. */
export async function shareInvite(code: string, nickname: string): Promise<ShareResult> {
  const url = inviteUrl(code);
  const text = `${nickname || 'A friend'} is challenging you in World of Trivia. Room ${code.toUpperCase()}: ${url}`;
  try {
    if (Capacitor.isNativePlatform()) {
      await Share.share({ title: 'World of Trivia', text, url, dialogTitle: 'Invite a friend' });
      return 'shared';
    }
    if (typeof navigator !== 'undefined' && navigator.share) {
      await navigator.share({ title: 'World of Trivia', text, url });
      return 'shared';
    }
  } catch {
    // user closed the sheet, or the platform refused: fall through to copy
  }
  try {
    await navigator.clipboard.writeText(text);
    return 'copied';
  } catch {
    return 'failed';
  }
}
